import { FC } from 'react';
import { Perform } from './perform';

interface PerformNumericProps {
    name: string;
    value?: number | undefined;
}

export const PerformNumeric: FC<PerformNumericProps> = ({ value, name }: PerformNumericProps) => {
    const text = value != null ? String(value) : '';
    return <Perform name={name} text={text} />;
};
